<script>
import Player from 'ne01-common/src/components/Player';
import { Howl } from 'howler';
import Checkbox from './Checkbox';

export default {
  name: 'Choice',
  props: {
    audioSrc: String,
    title: String,
    correctChoice: Boolean,
    answerSrc: String,
    isEnabled: Boolean,
  },
  components: {
    Player,
    Checkbox
  },
  data: () => ({
    selected: false
  }),
  mounted() {
    let that = this;
    this.sound = new Howl({ src: [this.answerSrc] });
    this.sound.on('end', function() {
      that.selected = true;
      that.$emit('isVoiceOver', false, that.correctChoice);
    });
  },
  methods: {
    buttonClicked: function() {
      if (!this.isEnabled || this.selected || this.sound.playing()) {
        return;
      }
      this.$store.dispatch('questionAnswered', this.correctChoice ? 'correct' : 'wrong');
      this.$emit('isVoiceOver', true);
      this.selected = true;
      this.sound.play();
    },
  }
};
</script>

<template>
  <div class="choice" v-bind:class="{'choice--selectable': isEnabled}">
    <checkbox class="choice__checkbox" v-bind:isCorrect="correctChoice" v-bind:isEnabled="isEnabled" v-on:clicked="buttonClicked()" />
    <Player class="choice__player" v-bind:src="audioSrc" :title="title" controls showProgress />
  </div>
</template>

<style scoped>
.choice {
  display: flex;
  align-items: center;
  padding: 1.2rem 0;
}

.choice__checkbox {
  margin-right: 2rem;
}

.choice__player {
  width: calc(100% - 5rem);
  transition: width 300ms linear 0;
}
.choice--selectable .choice__player {
  width: 100%;
}
</style>